import React from 'react';
import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID, ENGINE_SUB_TYPES_NAMES } from 'constants/boatApplication';

export default ({boatSpecifications, dualSteering, isFinalReview, goToStep, boatDetailsRequestInProcess}) => {
  if (boatDetailsRequestInProcess) return null;

  if (!boatSpecifications) return null;

  let additionalSectionTitle = '';
  if (boatSpecifications.motorType !== undefined) additionalSectionTitle = 'Motor Specification';
  else if (boatSpecifications.dieselPower) additionalSectionTitle = 'Fuel Type';

  const _getSubType = () => {
    const subType = ENGINE_SUB_TYPES_NAMES.find(subType => boatSpecifications.subType === subType.value);

    if (subType) {
      return subType.name;
    }

    return '';
  };

  return (
    <React.Fragment>
      <section className='scene_section'>
        <header>General info</header>
        {boatSpecifications.lengthFeet !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Overall Length'
            value={[boatSpecifications.lengthFeet, boatSpecifications.lengthInches]}
            units={['Ft.', 'In.']}
            decimalDigits={[0, 2]}
          />
        )}
        {boatSpecifications.maxBoatBeamFeet !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary'
            textClassName='text__text_primary'
            label='Max Boat Beam'
            value={[boatSpecifications.maxBoatBeamFeet, boatSpecifications.maxBoatBeamInches]}
            units={['Ft.', 'In.']}
            decimalDigits={[0, 2]}
          />
        )}
        {boatSpecifications.inboardLengthFeet !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Inboard Length'
            value={[boatSpecifications.inboardLengthFeet, boatSpecifications.inboardLengthInches]}
            units={['Ft.', 'In.']}
            decimalDigits={[0, 2]}
          />
        )}
        {boatSpecifications.inboardArea !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary'
            textClassName='text__text_primary'
            label='Inboard Area'
            value={boatSpecifications.inboardArea}
            units=' Lbs.'
            decimalDigits={2}
          />
        )}
        {boatSpecifications.bottomContour !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Bottom Contour'
            value={boatSpecifications.bottomContour}
            removeUnderlines
          />
        )}
        {boatSpecifications.weightOfFinishedBoat !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Weight of Finished Boat'
            value={boatSpecifications.weightOfFinishedBoat}
            units=' Lbs.'
          />
        )}
        {boatSpecifications.unavInboardArea !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary'
            textClassName='text__text_primary'
            label='Unavailable Inboard Area'
            value={boatSpecifications.unavInboardArea}
            units=' Sq. Ft.'
            decimalDigits={2}
          />
        )}
        {boatSpecifications.widthFeet !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary'
            textClassName='text__text_primary'
            label='Overall Stern Width'
            value={[boatSpecifications.widthFeet, boatSpecifications.widthInches]}
            units={['Ft.', 'In.']}
            decimalDigits={[0, 2]}
          />
        )}
        {boatSpecifications.transformHeightAtCenterline !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Transom Height at Centerline'
            value={boatSpecifications.transformHeightAtCenterline}
            units=' In.'
            decimalDigits={2}
          />
        )}
        {boatSpecifications.fuelTankCapacity !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary'
            textClassName='text__text_primary'
            label='Fuel Tank Capacity'
            value={boatSpecifications.fuelTankCapacity}
            units=' Gal.'
            decimalDigits={2}
          />
        )}
        {boatSpecifications.displacement !== undefined && (
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Displacement'
            value={boatSpecifications.displacement}
            units=' cc'
          />
        )}
        {isFinalReview && (
          <Button
            color={buttonColor.planeOrange}
            label='Edit'
            buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
            fontSize={14}
            onClick={() => goToStep(STEP_ID.BOAT_SPECIFICATIONS, true)}
          />
        )}
      </section>

      {boatSpecifications.transformFlag !== undefined && (
        <section className='scene_section'>
          <header>Air Chambers</header>
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Transom'
            value={boatSpecifications.transformFlag ? 'Yes' : 'No'}
          />
          {boatSpecifications.ribFlag !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary'
              textClassName='text__text_primary'
              label='RIB'
              value={boatSpecifications.ribFlag ? 'Yes' : 'No'}
            />
          )}
          {boatSpecifications.combinedAirChambersVolume !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary _margin_right_30'
              textClassName='text__text_primary'
              label='Combined Volume of all Air Chambers'
              value={boatSpecifications.combinedAirChambersVolume}
              units=' Cu. Ft.'
              decimalDigits={2}
            />
          )}
          {boatSpecifications.inherentBuoyancyVolume !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary'
              textClassName='text__text_primary'
              label='Inherent Buoyancy Volume'
              value={boatSpecifications.inherentBuoyancyVolume}
              units=' Cu. Ft.'
              decimalDigits={2}
            />
          )}
          {isFinalReview && (
            <Button
              color={buttonColor.planeOrange}
              label='Edit'
              buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
              fontSize={14}
              onClick={() => goToStep(STEP_ID.BOAT_SPECIFICATIONS, true)}
            />
          )}
        </section>
      )}

      {boatSpecifications.subType !== undefined && (
        <section className='scene_section'>
          <header>Engine</header>
          <Text
            mainWrapperClassName='text__wrapper_primary _margin_right_30'
            textClassName='text__text_primary'
            label='Motor Type'
            value={_getSubType()}
          />
          {isFinalReview && (
            <Button
              color={buttonColor.planeOrange}
              label='Edit'
              buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
              fontSize={14}
              onClick={() => goToStep(STEP_ID.BOAT_SPECIFICATIONS, true)}
            />
          )}
        </section>
      )}

      {additionalSectionTitle && (
        <section className='scene_section'>
          <header>{additionalSectionTitle}</header>
          {boatSpecifications.motorType !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary _margin_right_30'
              textClassName='text__text_primary'
              label='Motor Type'
              value={boatSpecifications.motorType}
            />
          )}
          {dualSteering !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary'
              textClassName='text__text_primary'
              label='Dual Steering'
              value={dualSteering ? 'Yes' : 'No'}
            />
          )}
          {boatSpecifications.hasElectricPropulsion !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary'
              textClassName='text__text_primary'
              label='Electric Propulsion'
              value={boatSpecifications.hasElectricPropulsion ? 'Yes' : 'No'}
            />
          )}
          {boatSpecifications.dieselPower !== undefined && (
            <Text
              mainWrapperClassName='text__wrapper_primary _margin_right_30'
              textClassName='text__text_primary'
              label='Diesel Power Type'
              value={boatSpecifications.dieselPowerCode}
            />
          )}
          {isFinalReview && (
            <Button
              color={buttonColor.planeOrange}
              label='Edit'
              buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
              fontSize={14}
              onClick={() => goToStep(STEP_ID.BOAT_SPECIFICATIONS, true)}
            />
          )}
        </section>
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/GeneralInfo.jsx